import RWD002 from "../class/rwd002";
import customDrawerNav from "./drawerNav";
import customFormConfirm from "./formConfirm";
import customSubNav from "./subNav";
import pageTopObserver from "./pageTopObserver";
import LazyDisp from "../class/lazydisp";

const [d,mq,l] = [document, window.matchMedia( "(max-width: 900px)" ), location];

export default class CUSTOMIZE extends RWD002 {

  constructor(opt) {
    opt = Object.assign({
      // fixNavを指定すると、スクロール時に固定するクラスを付与する
      fixNav : '[data-role="fixNav"]',
    },opt);

    // 上位クラスのコンストラクタ呼び出し
    super(opt);

    // カスタム用drawerNavのインスタンス化
    this.drawerNav = new customDrawerNav(this.opt.drawerNav);

    // カスタム用サブナビ登録クラスのインスタンス化
    this.Subnav = new customSubNav(this.opt);

    // コメントフォーム用確認画面モーダルのインスタンス化
    this.formConfirm = new customFormConfirm(this.opt.formConfirm);

    this.customInit();
  }

  customInit() {

    // イベント一覧
    d.addEventListener('rwd002.beforeInit', () => false );
    d.addEventListener('rwd002.beforeDomready', () => false );
    d.addEventListener('rwd002.beforeWindowload', () => false );
    d.addEventListener('rwd002.zip2addr', () => false );
    d.addEventListener('drawerNav.beforeInit', () => false );
    d.addEventListener('collapseNav.beforeInit', () => false );
    d.addEventListener('Scroll.beforeInit', () => false );
    d.addEventListener('Scroll.scrollUp', () => false );
    d.addEventListener('Scroll.scrollDown', () => false );
    d.addEventListener('Lazydisp.beforeInit', () => false );
    
    // テンプレートインスタンスのプロミス
    this.promises.init.then( () => false );
    this.promises.domReady.then( () => false );
    this.promises.windowLoad.then( () => false );
    
    // テンプレートインスタンスの全非同期メソッドの完了時に実行
    this.promiseAll().then( () => false );

    // サブナビ登録サンプル
    d.addEventListener('rwd002.beforeDomready', () => {
      this.customSubnav();
      const fixnav = d.querySelector('.rwd002-fixNav');
      if ( fixnav ) {
        const fixnav_closeBtn = fixnav.querySelector('[role="close"]')
        new pageTopObserver(fixnav);
        fixnav_closeBtn.addEventListener('click', () => fixnav.classList.add('is-close'));
      }
    });

    $(() => {
      // htmlデータ読み込み
      $('[data-load-html]').loadHtml();
      
      // カレントメニュー
      $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});

      Promise.all([window.load['loadHtml']]).then( () => this.hashscroll());
      Promise.all([window.load['loadHtml']]).then( () => new LazyDisp('[data-lazydisp]'));
    });
  }

  // サブメニュー追加サンプル(beforeDomreadyに登録して使用)
  customSubnav () {
    /**
     * サブナビ追加メソッド(グローバルナビとフッター)
     * ヘッダー・フッター内の[data-key]属性値をもつ要素すべてに対して、サブナビを追加する
     * 第一引数にセレクタを指定(rwd002.opt.gnav / rwd002.opt.fnav )
     * 第一引数にコンテンツ番号を指定(li[data-key])
     * アイテムの出力HTMLは"subnavItemTemplate"によって出力される
     * 第二引数の個別アイテムにHTMLを指定すると、デフォルトのHTMLを上書きする
     * 親要素liに[data-collapse="true"]を指定すると、サブナビを開閉するボタンを追加する
     */

    const getMaterialsCat = this.fetchCategories('materials');

    // header gnav用サブナビ追加
    this.Subnav.add(this.opt.gnav, 'content1', [
      { label: 'ソフトプレン工業について', href: '/about/'},
      { label: 'お客様対応について', href: '/about/?mode=detail&amp;article=2'},
    ]);
    this.Subnav.add(this.opt.gnav, 'content4', [
      { label: '代表挨拶', href: '/company/'},
      { label: '品質環境方針', href: '/company/#quality'},
      { label: '企業情報', href: '/company/?mode=detail&amp;article=2'},
      { label: '拠点／グループ会社', href: '/company/?mode=detail&amp;article=2#base'},
      { label: '沿革', href: '/company/?mode=detail&amp;article=2#history'},
    ]);
    this.Subnav.add(this.opt.gnav, 'content5', [
      { label: '採用情報', href: '/recruit/'},
      { label: '募集要項', href: '/recruit/#guidelines'},
    ]);

    getMaterialsCat.then( cats => {
      this.Subnav.add(this.opt.gnav, 'content3', cats.map(c => ({label: c.name, href: c.href})) );
    })

    // footer nav用サブナビ追加
    this.Subnav.add(this.opt.fnav, 'content1', [
      { label: 'ソフトプレン工業について', href: '/about/'},
      { label: 'お客様対応について', href: '/about/?mode=detail&amp;article=2'},
    ]);
    this.Subnav.add(this.opt.fnav, 'content4', [
      { label: '代表挨拶', href: '/company/'},
      { label: '企業情報', href: '/company/?mode=detail&amp;article=2'},
    ]);
    this.Subnav.add(this.opt.fnav, 'content5', [
      { label: '採用情報', href: '/recruit/'},
      { label: '募集要項', href: '/recruit/#guidelines'},
    ]);
  }

  fetchCategories (content) {
    return fetch(`/assets/api/getCategories/?content=${content}`)
      .then(r => r.json())
      .catch(e => { throw new Error(e)});
  }

  // 現在のページが一覧だったらtrue
  is_list() {
    return (/^\?mode=list(&tag=[^&]+|&cat=[^&]+|&m=[^&]+)?(&page=[\d]+)?$/.test( l.search ) || /^\?page=[\d]+/.test( l.search ) || l.search == "");
  }

}

